"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
exports.default = (0, styles_1.makeStyles)(function (theme) {
    return (0, styles_1.createStyles)({
        root: {
            "& .MuiPaper-root": {
                borderRadius: theme.spacing(2),
            },
        },
        actionContainer: {
            alignItems: "stretch",
            height: theme.spacing(6),
            justifyContent: "space-between",
            padding: 0,
            "& .MuiButtonBase-root": {
                borderRadius: 0,
                flex: 1,
            },
            "&.MuiDialogActions-spacing > :not(:first-child)": {
                marginLeft: 0,
            },
        },
        content: {
            lineHeight: 3,
            padding: "".concat(theme.spacing(3), "px ").concat(theme.spacing(3), "px ").concat(theme.spacing(5), "px"),
        },
        title: {
            padding: "14px 16px",
            "& .MuiTypography-h6": {
                fontSize: "16px",
                fontWeight: 800,
            },
        },
    });
});
